// src/slices/userProfile/thunk.ts
// Async thunks for User Profile

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getUserProfile,
  updateUserProfile,
  uploadCurrentUserAvatar,
} from 'helpers/fakebackend_helper';

// Fetch current user profile
export const fetchUserProfile = createAsyncThunk(
  'userProfile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserProfile();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi tải thông tin người dùng'
      );
    }
  }
);

// Update current user profile
export const updateProfile = createAsyncThunk(
  'userProfile/updateProfile',
  async ({ userId, data }: { userId: number; data: any }, { rejectWithValue }) => {
    try {
      const response = await updateUserProfile(userId, data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi cập nhật thông tin'
      );
    }
  }
);

// Upload current user avatar
export const uploadProfileAvatar = createAsyncThunk(
  'userProfile/uploadAvatar',
  async ({ userId, file }: { userId: number; file: File }, { rejectWithValue }) => {
    try {
      const response = await uploadCurrentUserAvatar(userId, file);
      const data = response.data || response;
      // Return the real FileStorage URL
      return data.avatarUrl;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi tải lên ảnh đại diện'
      );
    }
  }
);